import { render, staticRenderFns } from "./RegistrasiBerhasilComponent.vue?vue&type=template&id=70ff5e7e&scoped=true&"
import script from "./RegistrasiBerhasilComponent.vue?vue&type=script&lang=js&"
export * from "./RegistrasiBerhasilComponent.vue?vue&type=script&lang=js&"
import style0 from "./RegistrasiBerhasilComponent.vue?vue&type=style&index=0&id=70ff5e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff5e7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
